import { Component, Input, output } from '@angular/core';
import { CommonService, CommonHttpService } from '../../../shared/services';

@Component({
  selector: 'bi-favourite-reports',
  templateUrl: './favourite-reports.component.html',
  styleUrl: './favourite-reports.component.scss',
  standalone: false
})
export class FavouriteReportsComponent {
  @Input() Items: any = [];
  updateFavourite = output<any>();
  constructor(private _commonService: CommonService,
    private _commonHttpService: CommonHttpService) { }

  /**
   * This method is used to toggele the favorite 
   * @param item it holds the current item
   */
  toggleFavourite(item: any) {
    //console.log(item);
    //return;
    let isFavourite = (item.isFavourite == 1) ? 0 : 1;
    //let userId = (item.userId) ? item.userId : 0;
    let data = { id: null, isFavourite: isFavourite, reportId: item.reportId, reportFrom: item.reportFrom };
    if (item.favouriteReports) {
      data.id = item.favouriteReports[0].id;
    }
    this._commonHttpService.updateFavourite(data).subscribe((res: any) => {
      if (res.status === 1) {
        this.updateFavourite.emit(item);
      }
    });
  }
}
